import { useState } from "react";
import { X } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const galleryImages = [
  { src: "/images/gallery_dementia.jpg", alt: "Dementia memory care companionship" },
  { src: "/images/gallery_wheelchair.jpg", alt: "Warm wheelchair assistance at home" },
  { src: "/images/gallery_vitals.jpg", alt: "Vital signs monitoring at home" },
  { src: "/images/gallery_medication.jpg", alt: "Careful medication organization" },
  { src: "/images/gallery_meal.jpg", alt: "Healthy meal preparation" },
  { src: "/images/gallery_reading.jpg", alt: "Reading companionship and warmth" },
];

export const GallerySection = () => {
  const { language } = useLanguage();
  const [lightboxImg, setLightboxImg] = useState(null);

  const labels = {
    en: { title: "GALLERY", subtitle: "Our Care in Action" },
    es: { title: "GALERIA", subtitle: "Nuestro Cuidado en Accion" },
    pt: { title: "GALERIA", subtitle: "Nosso Cuidado em Acao" },
    fr: { title: "GALERIE", subtitle: "Nos Soins en Action" },
  }[language] || { title: "GALLERY", subtitle: "Our Care in Action" };

  return (
    <section data-testid="gallery-section" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-[#C89D4B] font-semibold uppercase tracking-widest text-sm">{labels.title}</span>
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#1A2332] mt-3">{labels.subtitle}</h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {galleryImages.map((img) => (
            <div
              key={img.alt}
              data-testid={`gallery-img-${img.alt}`}
              className="relative overflow-hidden rounded-2xl cursor-pointer group aspect-[4/3]"
              onClick={() => setLightboxImg(img)}
            >
              <img src={img.src} alt={img.alt} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
              <div className="absolute inset-0 bg-[#003A4B]/0 group-hover:bg-[#003A4B]/30 transition-colors flex items-center justify-center">
                <span className="text-white opacity-0 group-hover:opacity-100 transition-opacity font-medium text-sm">{img.alt}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {lightboxImg && (
        <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4" onClick={() => setLightboxImg(null)}>
          <button className="absolute top-6 right-6 text-white hover:text-[#C89D4B] transition-colors" onClick={() => setLightboxImg(null)}>
            <X className="w-8 h-8" />
          </button>
          <img src={lightboxImg.src.replace('w=600', 'w=1200')} alt={lightboxImg.alt} className="max-w-full max-h-[85vh] object-contain rounded-lg" onClick={e => e.stopPropagation()} />
        </div>
      )}
    </section>
  );
};
